<template>
    <div v-route-title="'用户组管理'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">用户组管理</span>
            </div>
            <div>
                <el-button @click="addRow">添加同级组</el-button>
                <el-button @click="addChildRow">添加下级组</el-button>
                <el-button @click="editRow">修改</el-button>
                <el-button @click="deleteRow">删除</el-button>
            </div>
            <div v-if="data">
                <el-table class="yq-table" :data="data" style="width: 100%" row-key="id"
                          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                          default-expand-all highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column
                            prop="name"
                            label="用户组名称">
                    </el-table-column>
                    <el-table-column
                            label="创建时间"
                            width="180">
                        <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                    </el-table-column>
                    <el-table-column
                            label="创建用户"
                            width="100">
                        <span slot-scope="scope">{{scope.row.creator?scope.row.creator.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="修改时间"
                            width="180">
                        <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                    </el-table-column>
                    <el-table-column
                            label="修改用户"
                            width="100">
                        <span slot-scope="scope">{{scope.row.editor?scope.row.editor.name:''}}</span>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改用户组':'添加用户组'" :visible.sync="dialogFormVisible" label>
            <el-form ref="form" :model="model" label-width="120px" :rules="rules">
                <el-form-item label="用户组名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import userService from '../service/user'
    import userGroupService from '../service/user-group'

    export default {
        name: "UserGroupAdmin",
        data() {
            const checkName = (rule, value, callback) => {
                if (value) {
                    userGroupService.checkUserGroupName(value).then(response => {
                        if (response.data && this.model.id !== response.data.id) {
                            callback(new Error('该用户组已存在'));
                        } else {
                            callback();
                        }
                    }).catch(() => {
                        callback(new Error('校验出错'));
                    })
                } else {
                    callback();
                }
            }
            return {
                data: null,
                currentRow: null,
                dialogFormVisible: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入用户组名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkName, trigger: 'blur'}
                    ]
                }
            }
        },
        created() {
            this.fetchData()
        },
        methods: {
            async fetchData() {
                let response = await userGroupService.listUserGroups()
                await userService.fetchCreatorAndEditor(response.data)
                const rootNodes = []
                for (const row of response.data) {
                    if (row.parent) {
                        let found
                        for (const parent of response.data) {
                            if (parent.id === row.parent.id) {
                                if (parent.children) {
                                    parent.children.push(row)
                                } else {
                                    parent.children = [row]
                                }
                                found = true
                                break
                            }
                        }
                        if (!found) {
                            rootNodes.push(row)
                        }
                    } else {
                        rootNodes.push(row)
                    }
                }
                this.data = rootNodes
            },
            handleCurrentChange(val) {
                this.currentRow = val;
            },
            addRow() {
                if(!this.currentRow || !this.currentRow.parent){
                    return
                }
                this.model = {
                    parent: this.currentRow ? (this.currentRow.parent ? {id: this.currentRow.parent.id} : null) : null
                }
                this.dialogFormVisible = true
            },
            addChildRow() {
                if (this.currentRow) {
                    this.model = {
                        parent: {id: this.currentRow.id}
                    }
                    this.dialogFormVisible = true
                }
            },
            editRow() {
                if (this.currentRow) {
                    if (!this.currentRow.parent) {
                        this.$message({
                            type: 'error',
                            message: '无法修改根用户组!'
                        })
                        return
                    }
                    const formData = {
                        id: this.currentRow.id,
                        name: this.currentRow.name,
                        province: this.currentRow.province
                    }
                    if (this.currentRow.parent) {
                        formData.parent = {
                            id: this.currentRow.parent.id
                        }
                    }
                    this.model = formData
                    this.dialogFormVisible = true
                }
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    if (this.model.id) {
                        userGroupService.updateUserGroup({
                            id: this.currentRow.id,
                            data: this.model
                        }).then(() => {
                            this.fetchData()
                            this.dialogFormVisible = false
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        userGroupService.addUserGroup(this.model).then(() => {
                            this.fetchData()
                            this.dialogFormVisible = false
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(() => {
                })
            },
            deleteRow() {
                if (this.currentRow) {
                    if (!this.currentRow.parent) {
                        this.$message({
                            type: 'error',
                            message: '无法删除根用户组!'
                        })
                        return
                    }
                    this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        userGroupService.deleteUserGroup(this.currentRow.id).then(() => {
                            this.fetchData()
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '删除失败!'
                            })
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                }
            }
        }
    }
</script>
